import * as React from 'react';
import { useIsDesktop } from '@cian/valuation-utils-component';
import * as styles from './styles.css';
import cn from 'classnames';
import { MenuContainer } from '../../containers/MenuContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SelectRealtorFiltersLayout = function SelectRealtorFiltersLayout(props) {
  var isDesktop = useIsDesktop();
  var dealTypeFilter = props.dealTypeFilter,
      objectTypeFilter = props.objectTypeFilter,
      offerTypeFilter = props.offerTypeFilter;

  if (!isDesktop) {
    return null;
  }

  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx(MenuContainer, {
      activeIndex: 5
    }), /*#__PURE__*/_jsx("form", {
      className: styles['form'],
      onSubmit: function onSubmit(e) {
        return e.preventDefault();
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: styles['filters'],
        children: [/*#__PURE__*/_jsx("div", {
          className: cn(styles['filter']),
          children: dealTypeFilter
        }), /*#__PURE__*/_jsx("div", {
          className: cn(styles['filter']),
          children: offerTypeFilter
        }), /*#__PURE__*/_jsx("div", {
          className: cn(styles['filter']),
          children: objectTypeFilter
        })]
      })
    })]
  });
};
SelectRealtorFiltersLayout.displayName = 'SelectRealtorFiltersLayout';